import { Box, ButtonNew, LoaderNew, ModBox, SpacerNew, TextNew, TextNewProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { AepsButton } from '../../../comps/AepsButton'
import { OtpTextInputWithTimer } from '../../../comps/OtpTextInputWithTimer'
import { RowItem } from '../../../comps/RowItem'
import { useLazyApiData, useStores } from '../../../data/store'
import { Screens } from '../../../nav/Screens'
import { getFormattedAmount } from '../../../util/utill'
import { DomesticMoneyTransferStrings } from '../Strings'
import { FundTransferStatus } from './FundTransferStatus'

interface RenderSplittedTnxProps {
  item: any
  index: any
  handleNext: any
  isLastItem: boolean
  invoiceNo: string
}

export const RenderSplittedTnx = ({
  item,
  handleNext,
  isLastItem = false,
  index,
  invoiceNo,
}: RenderSplittedTnxProps) => {
  const {
    beneficiaryFirstName,
    beneficiaryLastName,
    beneficiaryAccountNumber,
    getSplitTnxDetails,
    applicableChargesForTransaction,
    setMessage,
    updateIsBeneficiaryValidated,
    mobile,
    fetchFeeAndSendOtp,
    confirmFundTransfer,
    remittanceUserId,
    beneficiaryId,
    sendOtp,
    fetchRemittanceStatus,
    splittedTnxResponses,
  } = useStores((store) => ({
    beneficiaryFirstName: store.beneficiaryDetails.beneficiaryFirstName,
    beneficiaryLastName: store.beneficiaryDetails.beneficiaryLastName,
    beneficiaryAccountNumber: store.beneficiaryDetails.beneficiaryAccountNumber,
    getSplitTnxDetails: store.transactionDetails.getSplitTnxDetails,
    applicableChargesForTransaction: store.transactionDetails.applicableChargesForTransaction,
    setMessage: store.message.setMessage,
    updateIsBeneficiaryValidated: store.beneficiaryDetails.updateIsBeneficiaryValidated,
    mobile: store.customerDetails.mobile,
    fetchFeeAndSendOtp: store.moneyTransferSession.fetchFeeAndSendOtp,
    confirmFundTransfer: store.transactionDetails.confirmFundTransfer,
    remittanceUserId: store.customerDetails.remittanceUserId,
    beneficiaryId: store.beneficiaryDetails.beneficiaryId,
    sendOtp: store.moneyTransferSession.sendOtp,
    fetchRemittanceStatus: store.transactionDetails.fetchRemittanceStatus,
    splittedTnxResponses: store.transactionDetails.splittedTnxResponses,
    length: store.transactionDetails?.splittedTnxResponses?.length,
  }))
  const [lazyTransferFund, transferFundHandler] = useLazyApiData(confirmFundTransfer)
  const [lazySendOtp, sendOtpHandler] = useLazyApiData(sendOtp)
  const [fetchRemittanceStatusApi, fetchRemittanceStatusHandler] = useLazyApiData(fetchRemittanceStatus)

  const [otp, setOtp] = useState('')
  const navigation = useNavigation()

  useEffect(() => {
    if (['fulfilled', 'rejected'].includes(transferFundHandler?.state) && isLastItem) {
      console.log('in fullfiled')
      navigation.reset({
        index: 2,
        routes: [
          { name: Screens.DOMESTIC_MONEY_TRANSFER_HOME_SCREEN as never },
          {
            name: Screens.DOMESTIC_MONEY_TRANSFER_LOGIN as never,
          },
          {
            name: Screens.SPLIT_TRANSACTION_SUCCESS_SCREEN as never,
          },
        ],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferFundHandler?.state])

  useEffect(() => {
    if (sendOtpHandler?.state === 'fulfilled') {
      console.log('htag in fullfiled', sendOtpHandler?.state, index)
      handleNext()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendOtpHandler?.state])

  const fetchStatus = useCallback(() => {
    console.log('transferFundHandler', transferFundHandler?.data)
    fetchRemittanceStatusApi(transferFundHandler?.data?.idempotentKey)
  }, [fetchRemittanceStatusApi, transferFundHandler?.data])

  const onSubmitPress = useCallback(() => {
    if (!transferFundHandler?.state) {
      const POST_DATA = {
        charges: item?.charge,
        remittanceUserId,
        mobile,
        beneficiaryId,
        totalConvenienceFee: item?.grossAmount - item?.amount,
        amountEnteredByUser: item?.amount,
        otp,
        invoiceNo,
        index,
      }
      lazyTransferFund(POST_DATA)
    } else {
      lazySendOtp(mobile, { mode: 33, purpose: 9, amount: item?.amount })
    }
  }, [
    beneficiaryId,
    index,
    invoiceNo,
    item?.amount,
    item?.charge,
    item?.grossAmount,
    lazySendOtp,
    lazyTransferFund,
    mobile,
    otp,
    remittanceUserId,
    transferFundHandler?.state,
  ])
  const onSkipPress = useCallback(() => {
    if (isLastItem) {
      navigation.reset({
        index: 2,
        routes: [
          { name: Screens.DOMESTIC_MONEY_TRANSFER_HOME_SCREEN as never },
          {
            name: Screens.DOMESTIC_MONEY_TRANSFER_LOGIN as never,
          },
          {
            name: Screens.SPLIT_TRANSACTION_SUCCESS_SCREEN as never,
          },
        ],
      })
    } else {
      handleNext()
    }
  }, [handleNext, isLastItem, navigation])

  return (
    <Box width={Dimensions.get('window').width - 66}>
      <SpacerNew size={24} />
      <RowItem heading={'Invoice No.'} detail={invoiceNo} />
      <SpacerNew size={8} />
      <RowItem
        heading={DomesticMoneyTransferStrings.beneficiaryName}
        detail={`${(beneficiaryFirstName ?? '') + ' ' + (beneficiaryLastName ?? '')}`}
      />
      <SpacerNew size={8} />
      <RowItem heading={DomesticMoneyTransferStrings.beneficiaryAct} detail={beneficiaryAccountNumber} />
      <SpacerNew size={8} />
      <RowItem heading={DomesticMoneyTransferStrings.amount} detail={getFormattedAmount(item?.amount)} />
      <SpacerNew size={4} />
      <TextNew
        {...styles.applicableCharges}
        title={`${DomesticMoneyTransferStrings.applicableCharges} ${getFormattedAmount(
          item?.grossAmount - item?.amount,
        )}`}
      />
      <ModBox show={!['fulfilled', 'rejected'].includes(transferFundHandler?.state)}>
        <OtpTextInputWithTimer
          mobileNumber={mobile}
          isResendOtpLoading={false}
          value={otp}
          onChangeText={setOtp}
          onResendOtpButtonPress={undefined}
          mode={33}
          purpose={9}
        />
        <ButtonNew title={'Skip'} onPress={onSkipPress} type={'tertiary'} width={40} />
      </ModBox>
      <SpacerNew size={16} />
      <FundTransferStatus
        state={fetchRemittanceStatusHandler?.state === 'fulfilled' ? 'fulfilled' : transferFundHandler?.state}
        data={splittedTnxResponses?.find((tnx) => tnx?.index === index)}
        onPress={fetchStatus}
      />
      <SpacerNew size={24} />
      <AepsButton
        title={!['fulfilled', 'rejected'].includes(transferFundHandler?.state) ? 'Proceed to Fund transfer' : 'Next'}
        onPress={onSubmitPress}
        disabled={
          (sendOtpHandler?.state !== 'fulfilled' && otp.length != 6) ||
          ['pending', 'fulfilled'].includes(sendOtpHandler?.state)
        }
        isLoading={[transferFundHandler?.state, sendOtpHandler?.state].includes('pending')}
      />
      <SpacerNew size={48} />
      <ModBox
        position={'absolute'}
        height={'100%'}
        width={'100%'}
        justifyContent={'center'}
        show={fetchRemittanceStatusHandler?.state === 'pending'}>
        <LoaderNew color={'PRIMARY'} type={'small'} />
      </ModBox>
    </Box>
  )
}

const styles = {
  applicableCharges: {
    fontSize: 12,
    fontFamily: 'jiotype-medium',
    textAlign: 'left',
    color: 'BRAND_COLOR_GRAY_2',
  } as TextNewProps,
}
